<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    window.location.replace('https://app.xueersi.com/xueersi-mall-hm-xbjtoxes/certification')
  }
}
</script>



// WEBPACK FOOTER //
// ./src/views/BusinessLicense/index.vue